<!-- Container -->
<div class="container-sm">

  <ul>
    <li>
      Follow the steps below on the phone you plan to use for recording your logbook.
      At this time, your data is only saved on your phone
      (if you log in to a different device, you will not see saved data).
    </li>
  </ul>

  <h2 class="help-header">
    For Apple iPhone:
  </h2>

  <ul>
    <li>
      Open the Safari app
    </li>
    <li>
      Access the app via the website:
      <a [href]="website"
         [target]="linkType">
        {{website}}
      </a>
    </li>
    <li>
      Allow the app to access your location for easy data collection, when prompted.
    </li>

    <li class="img-to-text">
      Select the "share" icon

      <!-- download_icon.png -->
      <img [src]="getImgs[0]"
           (click)="showImage(getImgs[0])" />

      and choose "Add to Home Screen"
      (you may need to scroll down to see this option)

      <div class="row">
        <!-- safari_download.png -->
        <img [src]="getImgs[1]"
        class="help-img"
        (click)="showImage(getImgs[1])" />

        <!-- add_to_screen.png -->
        <img [src]="getImgs[2]"
        class="help-img"
        (click)="showImage(getImgs[2])" />
      </div>
      
    </li>
    <li>
      Leave the Safari app and tap on the new app on your phone's home screen –
      this is where you will find the app from now on.
    </li>
  </ul>

  <h2 class="help-header">
    For Android phones:
  </h2>

  <ul>
    <li>
      Open the Chrome app
    </li>
    <li>
      Access the app via the website:
      <a [href]="website"
         [target]="linkType">
        {{website}}
      </a>
    </li>
    <li>
      Allow the app to access your location for easy data collection, when prompted.
    </li>

    <li class="help-ul">
      The app may prompt you to add to your home screen at the bottom of the screen, if so:
      <ul>

        <li class="img-to-text">
          Tap on the prompt.

          <!-- install_prompt.png -->
          <img [src]="getImgs[3]"
               class="help-img"
               (click)="showImage(getImgs[3])" />

        </li>
        <li>
          Leave the Chrome app and tap on the new app on your phone's home screen –
          this is where you will find the app from now on.
        </li>
      </ul>
    </li>

    <li class="help-ul">
      If you do not receive a prompt, follow these steps:
      <ul>
        <li class="img-to-text">
          Click the 3-dot icon in the upper right corner, select the install app option.

          <div class="row">
            <!-- chrome_download.png -->
            <img [src]="getImgs[4]"
            class="help-img"
            (click)="showImage(getImgs[4])" />
          </div>
          
          <div class="row">
            <!-- install_app_banner.png -->
            <img [src]="getImgs[5]"
              class="help-img"
              (click)="showImage(getImgs[5])" />
          </div>
          
        </li>
      </ul>
    </li>
    <li>
      Leave the Chrome app and tap on the new app on your phone’s home screen –
      this is where you will find the app from now on.
    </li>
  </ul>

</div>
